import React from 'react';
import TrashIcon from 'src/common/utils/TableColumnIcons/TrashIcon';

export const ActionColumnDelete = (value, row, rowIndex, { onDelete }) => {
	return (
		<>
			<TrashIcon onClick={() => onDelete(row)} color="#808080" />
		</>
	);
};
